import React from 'react';
import PropTypes from 'prop-types';

import {
  thumbnailPlaceholder,
  thumbnailProcessing,
  thumbnailLink,
} from '../../helpers/Files';

const UploadFileThumbnail = ({
  completed,
  error,
  file,
}) => {
  if (error) {
    return (
      <img
        className="grid-item-img"
        src={thumbnailPlaceholder}
        alt=""
      />
    );
  }

  if (file.type === 'link' && file.urls) {
    return (
      <img
        className="grid-item-img"
        src={file.urls.thumbnail}
        srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
        alt={file.name}
      />
    );
  }

  if (file.website && file.website.thumbnail) {
    return (
      <img
        className="grid-item-img"
        src={file.website.thumbnail}
        alt={file.website.name}
      />
    );
  }

  if (file.type === 'link') {
    return (
      <img
        className="grid-item-img"
        src={thumbnailLink}
        alt=""
      />
    );
  }

  if (completed && file.urls) {
    return (
      <img
        className="grid-item-img"
        src={file.urls.thumbnail}
        srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
        alt={file.name}
      />
    );
  }

  return (
    <img
      className="grid-item-img"
      src={thumbnailProcessing}
      alt=""
    />
  );
};

UploadFileThumbnail.propTypes = {
  completed: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  file: PropTypes.object,
};

UploadFileThumbnail.defaultProps = {
  file: null,
};

export default UploadFileThumbnail;
